module.exports = __webpack_public_path__ + "media/images/product/c_d-60e43a71b0cab1143425fc3d9d3d9726.jpg";